import { createAction } from "@reduxjs/toolkit";

const FETCH_STUDENT_MODULES = 'FETCH_STUDENT_MODULES';
const FETCH_SUB_MODULES = 'FETCH_SUB_MODULES';
const CREATE_MEETING_EXERCISE_VIEW = 'CREATE_MEETING_EXERCISE_VIEW';
const FETCH_MEETING_EXERCISE_VIEWS = 'FETCH_MEETING_EXERCISE_VIEWS';
const UPDATE_EXERCISE_TABS = 'UPDATE_EXERCISE_TABS';
const SET_VIEW_RESULT_EXERCISE_ID = 'SET_VIEW_RESULT_EXERCISE_ID';
const FETCH_MEETING_EXERCISE_ACTIVITY = 'FETCH_MEETING_EXERCISE_ACTIVITY';
const EXPORT_MEETING_EXERCISE_ACTIVITY = 'EXPORT_MEETING_EXERCISE_ACTIVITY';
const SET_EDX_DOCUMENT_BLOCK_ID = 'SET_EDX_DOCUMENT_BLOCK_ID';
const FETCH_MEETING_SUB_MODULE_DETAIL = 'STUDENT_ANSWER_EXERCISE_QUESTION';
const MEETING_STUDENT_ANSWER_QUESTION = 'MEETING_STUDENT_ANSWER_QUESTION';
const MEETING_STUDENT_END_SUB_MODULE_SESSION = 'MEETING_STUDENT_END_SUB_MODULE_SESSION';
const RESET_MEETING_EXERCISE_DATA = 'RESET_MEETING_EXERCISE_DATA';
const START_EXERCISE_SESSION = 'START_EXERCISE_SESSION';
const DELETE_EXERCISE_SESSION = 'DELETE_EXERCISE_SESSION';
const SET_SELECTED_EXERCISE = 'SET_SELECTED_EXERCISE';

export const fetchStudentModules = createAction(FETCH_STUDENT_MODULES);
export const fetchSubModules = createAction<{ moduleId: string | number }>(FETCH_SUB_MODULES);
export const createMeetingExerciseView = createAction<{ 
  name: string, 
  meeting_id: number | string,
  school_id: number | string,
  class_id: number | string,
  questions: Array<{
    block_id_question: string,
    name_question: string,
    type_question: string
  }>,
  onSuccess?: () => void,
  onError?: () => void
}>(CREATE_MEETING_EXERCISE_VIEW);
export const fetchMeetingExerciseViews = createAction<{ 
  meeting_id: number | string
}>(FETCH_MEETING_EXERCISE_VIEWS);
export const updateExerciseTabs = createAction<Array<{
  id: string,
  title: string,
  favicon: string,
  active: boolean,
}>>(UPDATE_EXERCISE_TABS); 
export const setViewResultExerciseId = createAction(
  SET_VIEW_RESULT_EXERCISE_ID,
  (id: string | null, name?: string | null) => ({
    payload: { id, name: name ?? null },
  }),
);
export const fetchMeetingExerciseActivity = createAction<{
  meeting_id: number | string,
  exercise_id: string | number
}>(FETCH_MEETING_EXERCISE_ACTIVITY);
// Export kết quả bài tập ra Excel; không truyền exercise_id thì BE export tất cả bài tập của meeting (mỗi bài 1 sheet)
export const exportMeetingExerciseActivity = createAction<{
  meeting_id: number | string,
  exercise_id?: string | number
}>(EXPORT_MEETING_EXERCISE_ACTIVITY);
export const setEdxDocumentBlockId = createAction(
  SET_EDX_DOCUMENT_BLOCK_ID,
  (blockId: string | null, name?: string | null) => ({
    payload: { blockId, name: name ?? null },
  }),
); 

// New action to set selected exercise for doing
export const setSelectedExercise = createAction<{
  id: string | number,
  data: any
}>(SET_SELECTED_EXERCISE);

// New Meeting Exercise Actions
export const studentAnswerExerciseQuestion = createAction(FETCH_MEETING_SUB_MODULE_DETAIL, (questionId: string) => ({
  payload: {
    questionId
  }
}));

export const meetingStudentAnswerQuestion = createAction(MEETING_STUDENT_ANSWER_QUESTION, (questionId: string) => ({
  payload: {
    questionId
  }
}));

export const meetingStudentEndSubModuleSession = createAction(MEETING_STUDENT_END_SUB_MODULE_SESSION, (sessionId: string) => ({
  payload: {
    sessionId
  }
}));

export const startExerciseSession = createAction(START_EXERCISE_SESSION, (meeting_id: string | number, exercise_id: string | number) => ({
  payload: {
    meeting_id,
    exercise_id
  }
}));

export const deleteExerciseSession = createAction(DELETE_EXERCISE_SESSION, (meeting_id: string | number, exercise_id: string | number) => ({
  payload: {
    meeting_id,
    exercise_id
  }
}));

export const resetMeetingExerciseData = createAction(RESET_MEETING_EXERCISE_DATA); 